import accountConstants from "../constants/accountConstants";

export const createAccount = (payload: any) => ({
  type: accountConstants.ADD_ACCOUNT_REQ,
  payload,
});

export const getClients = (payload: any) => ({
  type: accountConstants.GET_CLIENTS_REQUEST,
  payload,
});

export const getAllClients = () => ({
  type: accountConstants.GET_ALL_CLIENTS_REQUEST,
});

export const editClientInfo = (payload: any) => ({
  type: accountConstants.EDIT_CLIENT_INFO_REQUEST,
  payload,
});

export const editClientFilter = (payload: any) => ({
  type: accountConstants.EDIT_CLIENT_FILTER_REQUEST,
  payload,
});

export const getClientTypes = () => ({
  type: accountConstants.GET_CLIENT_TYPES_REQUEST,
});

/* public api of Client types */
export const getSignupCategory = () => ({
  type: accountConstants.GET_SIGNUP_CATEGORY_REQUEST,
});

export const getSingleClient = (id: string) => ({
  type: accountConstants.GET_SINGLE_CLIENT_REQUEST,
  id,
});

export const getIsClientShareExist = (payload: any) => ({
  type: accountConstants.GET_IS_CLIENT_SHARE_EXIST_REQUEST,
  payload,
});

export const getClientAdjustmentAmount = (payload: any) => ({
  type: accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_REQUEST,
  payload,
});

export const getNoPageClientAdjAmount = (payload: any) => ({
  type: accountConstants.GET_NO_PAGE_ADJUSTMENT_AMOUNT_REQUEST,
  payload,
});

export const paymentWithAdjustment = (payload: any) => ({
  type: accountConstants.PAYMENT_WITH_ADJUSTMENT_REQUEST,
  payload,
});

export const resetExistedClientShare = () => ({
  type: accountConstants.RESET_EXISTED_CLIENT_SHARE_CLIENT,
});

export const resetClientFilterEditError = () => ({
  type: accountConstants.RESET_CLIENT_FILTER_EDIT_ERROR,
});

export const resetClient = () => ({
  type: accountConstants.RESET_CLIENT,
});

export const resetClients = () => ({
  type: accountConstants.RESET_CLIENTS,
});
